import { c as _c } from "react/compiler-runtime";
import { featureFlagAtom, FeatureFlagEnum } from '@states/featureFlagAtom';
import { useJotaiValue } from '@states/jotai/hooks';
export type TUseFeatureFlagsReturn = {
  isFeatureEnabled: (flag: FeatureFlagEnum) => boolean;
  isCmsBasedVerifyDetailsContentEnabled: boolean;
  isConsumerActivityLogEnabled: boolean;
  isConsumerAnchorSearchEnabled: boolean;
  isContractActionsEnabled: boolean;
  isContractActivityLogEnabled: boolean;
  isContractPdfLinkShown: boolean;
  isPayByBankEnabled: boolean;
  isPayByBankAutoRefreshEnabled: boolean;
  isTabSystemEnabled: boolean;
  isSavesEnabled: boolean;
  isTransactionActionsEnabled: boolean;
  isDeferredCallRedirectEnabled: boolean;
  isTrainingEnabled: boolean;
  isPostDateOnMissingDownPaymentEnabled: boolean;
  isCustomerOwnsVehicleEnabled: boolean;
  isStopTransferEnabled: boolean;
  isConsumerPageRedesignEnabled: boolean;
  isNotesV2Enabled: boolean;
  isDarkModeToggleEnabled: boolean;
  isDownloadPrrBreakdownEnabled: boolean;
  isCarfaxAllReportsEnabled: boolean;
  isEnduranceClaimsHistoryEnabled: boolean;
  isFavoriteConsumersEnabled: boolean;
  isHomeWarrantyClaimsEnabled: boolean;
};
export function useFeatureFlags() {
  const $ = _c(75);
  const {
    featureFlags
  } = useJotaiValue(featureFlagAtom);
  let t0;
  let t1;
  if ($[0] !== featureFlags) {
    t0 = flag => featureFlags.includes(flag);
    t1 = featureFlags.includes(FeatureFlagEnum.CmsBasedVerifyDetailsContent);
    $[0] = featureFlags;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== featureFlags) {
    t2 = featureFlags.includes(FeatureFlagEnum.ConsumerActivityLog);
    $[3] = featureFlags;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== featureFlags) {
    t3 = featureFlags.includes(FeatureFlagEnum.ContractActions);
    $[5] = featureFlags;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== featureFlags) {
    t4 = featureFlags.includes(FeatureFlagEnum.ContractActivityLog);
    $[7] = featureFlags;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== featureFlags) {
    t5 = featureFlags.includes(FeatureFlagEnum.ContractPdf);
    $[9] = featureFlags;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== featureFlags) {
    t6 = featureFlags.includes(FeatureFlagEnum.ConsumerAnchorSearch);
    $[11] = featureFlags;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== featureFlags) {
    t7 = featureFlags.includes(FeatureFlagEnum.PayByBank);
    $[13] = featureFlags;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== featureFlags) {
    t8 = featureFlags.includes(FeatureFlagEnum.PayByBankAutoRefresh);
    $[15] = featureFlags;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== featureFlags) {
    t9 = featureFlags.includes(FeatureFlagEnum.TabSystem);
    $[17] = featureFlags;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== featureFlags) {
    t10 = featureFlags.includes(FeatureFlagEnum.Saves);
    $[19] = featureFlags;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== featureFlags) {
    t11 = featureFlags.includes(FeatureFlagEnum.TransactionActions);
    $[21] = featureFlags;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== featureFlags) {
    t12 = featureFlags.includes(FeatureFlagEnum.DeferredCallRedirect);
    $[23] = featureFlags;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== featureFlags) {
    t13 = featureFlags.includes(FeatureFlagEnum.Training);
    $[25] = featureFlags;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== featureFlags) {
    t14 = featureFlags.includes(FeatureFlagEnum.PostDateOnMissingDownPayment);
    $[27] = featureFlags;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== featureFlags) {
    t15 = featureFlags.includes(FeatureFlagEnum.CustomerOwnsVehicle);
    $[29] = featureFlags;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== featureFlags) {
    t16 = featureFlags.includes(FeatureFlagEnum.StopTransfer);
    $[31] = featureFlags;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== featureFlags) {
    t17 = featureFlags.includes(FeatureFlagEnum.ConsumerPageRedesign);
    $[33] = featureFlags;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== featureFlags) {
    t18 = featureFlags.includes(FeatureFlagEnum.NotesV2);
    $[35] = featureFlags;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== featureFlags) {
    t19 = featureFlags.includes(FeatureFlagEnum.DarkModeToggle);
    $[37] = featureFlags;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== featureFlags) {
    t20 = featureFlags.includes(FeatureFlagEnum.DownloadPrrBreakdown);
    $[39] = featureFlags;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== featureFlags) {
    t21 = featureFlags.includes(FeatureFlagEnum.CarfaxAllReports);
    $[41] = featureFlags;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== featureFlags) {
    t22 = featureFlags.includes(FeatureFlagEnum.EnduranceClaimsHistory);
    $[43] = featureFlags;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== featureFlags) {
    t23 = featureFlags.includes(FeatureFlagEnum.FavoriteConsumersDevOnly);
    $[45] = featureFlags;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== featureFlags) {
    t24 = featureFlags.includes(FeatureFlagEnum.HomeWarrantyClaims);
    $[47] = featureFlags;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t0 || $[50] !== t1 || $[51] !== t10 || $[52] !== t11 || $[53] !== t12 || $[54] !== t13 || $[55] !== t14 || $[56] !== t15 || $[57] !== t16 || $[58] !== t17 || $[59] !== t18 || $[60] !== t19 || $[61] !== t2 || $[62] !== t20 || $[63] !== t21 || $[64] !== t22 || $[65] !== t23 || $[66] !== t24 || $[67] !== t3 || $[68] !== t4 || $[69] !== t5 || $[70] !== t6 || $[71] !== t7 || $[72] !== t8 || $[73] !== t9) {
    t25 = {
      isFeatureEnabled: t0,
      isCmsBasedVerifyDetailsContentEnabled: t1,
      isConsumerActivityLogEnabled: t2,
      isContractActionsEnabled: t3,
      isContractActivityLogEnabled: t4,
      isContractPdfLinkShown: t5,
      isConsumerAnchorSearchEnabled: t6,
      isPayByBankEnabled: t7,
      isPayByBankAutoRefreshEnabled: t8,
      isTabSystemEnabled: t9,
      isSavesEnabled: t10,
      isTransactionActionsEnabled: t11,
      isDeferredCallRedirectEnabled: t12,
      isTrainingEnabled: t13,
      isPostDateOnMissingDownPaymentEnabled: t14,
      isCustomerOwnsVehicleEnabled: t15,
      isStopTransferEnabled: t16,
      isConsumerPageRedesignEnabled: t17,
      isNotesV2Enabled: t18,
      isDarkModeToggleEnabled: t19,
      isDownloadPrrBreakdownEnabled: t20,
      isCarfaxAllReportsEnabled: t21,
      isEnduranceClaimsHistoryEnabled: t22,
      isFavoriteConsumersEnabled: t23,
      isHomeWarrantyClaimsEnabled: t24
    };
    $[49] = t0;
    $[50] = t1;
    $[51] = t10;
    $[52] = t11;
    $[53] = t12;
    $[54] = t13;
    $[55] = t14;
    $[56] = t15;
    $[57] = t16;
    $[58] = t17;
    $[59] = t18;
    $[60] = t19;
    $[61] = t2;
    $[62] = t20;
    $[63] = t21;
    $[64] = t22;
    $[65] = t23;
    $[66] = t24;
    $[67] = t3;
    $[68] = t4;
    $[69] = t5;
    $[70] = t6;
    $[71] = t7;
    $[72] = t8;
    $[73] = t9;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  return t25;
}